// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3FSrx","inputDescription":"styles_inputDescription__38jWZ"};